class Controller {
  constructor(Sections) {
    "ngInject";

    this.sections = Sections.plansSections;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/captainInvoice/captainInvoice.controller.js